import React from 'react';
import SEO from 'react-seo-component';
import { useQuery } from '@apollo/react-hooks';

import './mobile-collection-style.scss';

import MobileProductListPageSkeleton from '@src/componentsNew/Skeleton/mobile/page/MobileProductListPageSkeleton';
import { NoResult } from '@src/components/molecules';
import TopButton from '@src/componentsNew/Buttons/TopButton/TopButton';
import MobileCollectionProductListTemplate from '@src/componentsNew/ProductListTemplate/Collection/MobileCollectionProductListTemplate';

import { COLLECTION_FOR_SEO } from './queries';
import { collectionForSEO } from './__generated__/collectionForSEO';

import useScroll from '@src/hooks/useScroll';
import { getGraphqlIdFromDBId } from '@utils';
import { productsUrl } from '@src/app/routes';

const MobileCollectionPage = ({ match }) => {
  const { isScrolled, scrollTop } = useScroll();
  const collectionId = getGraphqlIdFromDBId(match.params.id, 'Collection');

  const { data, loading } = useQuery<collectionForSEO>(COLLECTION_FOR_SEO, {
    variables: {
      id: collectionId,
    },
  });

  if (loading) {
    return <MobileProductListPageSkeleton type="normal" />;
  }

  return data?.collection ? (
    <div id="mobile-brand-product-list-wrapper">
      <SEO
        title={data.collection.seoTitle ?? ''}
        titleTemplate={data?.shop.name}
        titleSeparator={`-`}
        description={data.collection.seoDescription ?? ''}
        image={data.collection.backgroundImage?.url}
        pathname={`${data?.shop.domain.url}${productsUrl}collection/${data.collection.slug}/`}
        siteLanguage="en"
        siteLocale="en_GB"
        twitterUsername=""
      />

      <MobileCollectionProductListTemplate
        collectionName={data.collection.name}
        collectionGraphqlId={data.collection.id}
      />

      {isScrolled && <TopButton isMobile={true} onClick={scrollTop} />}
    </div>
  ) : (
    <NoResult />
  );
};

export default MobileCollectionPage;
